/**
 * Business Unit Adapter
 * Transforms business unit data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type { BusinessUnit, BusinessUnitDto } from '@/types';

export class BusinessUnitAdapter extends BaseAdapter {
  static fromApi(dto: BusinessUnitDto): BusinessUnit {
    return {
      // Kept as a string on purpose: machine's id is a BIGINT, so Number() would lose
      // precision on a large one and every comparison downstream would silently miss.
      id: String(dto.id),
      name: dto.name,
      slug: dto.slug,
      status: dto.status,
      isDefault: Boolean(dto.is_default),
    };
  }

  static fromApiList(dtos: BusinessUnitDto[]): BusinessUnit[] {
    return (dtos ?? []).map((dto) => BusinessUnitAdapter.fromApi(dto));
  }
}
